"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DownloadAuditTrailButton = void 0;
var AcceptFlowContextProvider_1 = require("@CommonFrontend/AcceptFlow/AcceptFlowContextProvider");
var MaybeWrap_1 = __importDefault(require("@CommonFrontend/Utils/MaybeWrap"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var react_1 = __importStar(require("react"));
var DownloadAuditTrailButton = function () {
    var _a = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), settings = _a.settings, isPreviewAccept = _a.isPreviewAccept, auditTrailPdfUrl = _a.auditTrailPdfUrl, telemetry = _a.telemetry;
    var _b = __read((0, react_1.useState)(false), 2), isPolling = _b[0], setIsPolling = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), showSuccessState = _c[0], setShowSuccessState = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), showErrorState = _d[0], setShowErrorState = _d[1];
    var pollingTimeout = (0, react_1.useRef)();
    var buttonSuccessTimeout = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        var wait = 3000;
        var maxTries = 10;
        var counter = 1;
        var check = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, ready;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!auditTrailPdfUrl) return [3, 2];
                        return [4, fetch(auditTrailPdfUrl)];
                    case 1:
                        res = _a.sent();
                        ready = res.status === 200;
                        if (ready) {
                            telemetry.track("Accepted PDF Downloaded", { accepted_pdf_downloaded_source: "success" });
                            window.open(auditTrailPdfUrl);
                            setIsPolling(false);
                            setShowSuccessState(true);
                        }
                        else if (counter >= maxTries) {
                            setIsPolling(false);
                            setShowErrorState(true);
                        }
                        else {
                            counter++;
                            pollingTimeout.current = setTimeout(function () {
                                check();
                            }, wait);
                        }
                        _a.label = 2;
                    case 2: return [2];
                }
            });
        }); };
        if (isPolling && auditTrailPdfUrl) {
            check();
        }
        return function () {
            if (pollingTimeout.current) {
                clearTimeout(pollingTimeout.current);
            }
        };
    }, [isPolling, auditTrailPdfUrl, telemetry]);
    (0, react_1.useEffect)(function () {
        if (showSuccessState) {
            buttonSuccessTimeout.current = setTimeout(function () {
                setShowSuccessState(false);
            }, 1000);
        }
        return function () {
            if (buttonSuccessTimeout.current) {
                clearTimeout(buttonSuccessTimeout.current);
            }
        };
    }, [showSuccessState, buttonSuccessTimeout]);
    return (react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (content) {
            if (isPreviewAccept) {
                return (react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "PDF download is not available for Preview Accept Mode", size: kaleidoscope_1.TooltipSize.Large }, content));
            }
        } },
        react_1.default.createElement("div", null,
            react_1.default.createElement(kaleidoscope_1.Button, { width: "full", size: kaleidoscope_1.ButtonSize.Large, type: kaleidoscope_1.ButtonType.Secondary, buttonState: showSuccessState ? kaleidoscope_1.ButtonState.Success : isPolling ? kaleidoscope_1.ButtonState.Waiting : kaleidoscope_1.ButtonState.Idle, onClick: function () {
                    setShowErrorState(false);
                    if (isPreviewAccept) {
                        return;
                    }
                    setIsPolling(true);
                } },
                react_1.default.createElement(icons_1.Download, null), "Download ".concat(settings.esignEnabled ? "signed" : "accepted", " PDF")),
            react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: showErrorState, timeout: kaleidoscope_1.AnimationDuration.Short, "aria-live": "polite" }, function (_a) {
                var expandableElementRef = _a.expandableElementRef;
                return (react_1.default.createElement("div", { ref: expandableElementRef },
                    react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Error", alertType: kaleidoscope_1.AlertType.Error }, "Failed to download PDF, please try again.")));
            }))));
};
exports.DownloadAuditTrailButton = DownloadAuditTrailButton;
